import { PartnerAPIConfig, SmartHomeConfig } from '../../models';
import { Env } from '@backoffice/fast-payments-client-js-sdk';

const partnerConfig: PartnerAPIConfig = require(`./${globals.REACT_APP_PARTNER}`).default;

const config: SmartHomeConfig = {
  FAST_PAYMENT_ENV: Env.prod,
  CREATE_TRANSACTION_URL: 'https://pbgw.newcorp.com/web/service/processTransactionXDomain',
  SH_ENROLLMENT_API_BASE_URL: 'https://sh-enrollment-api.anywhereexpert.us/',
  SH_USER_DETAILS_API_BASE_URL: 'https://ssp-web-svc-api.anywhereexpert.us/graphql',
  SH_USER_POOL_API_BASE_URL: 'https://sh-web-user-pool-api.anywhereexpert.us/',
  IS_DEMO_MODE: false,
  RECAPTCHA_V2_SITE_KEY: '6LfpC4MUAAAAAHO6q0_MfVdhmo3TpZLUY2zz2anz',
  RECAPTCHA_V3_SITE_KEY: '6LdkDYMUAAAAAPUXfHG-dtLCMsQhxgGTn-RoJk38',
  MIXPANEL_TOKEN_SONASH: 'a3a184688c79ed56e48a703b360cc8ca',
  ...partnerConfig,
};

export default config;



// WEBPACK FOOTER //
// ./packages/smart-home-support/api/config/prod/index.ts